import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fetchCropsFailure,
  fetchCropsStart,
  fetchCropsSuccess,
} from "../../store/features/crops/cropsSlice";

const URL = buildApiUrl("/api/v1/colture/colture/");

const getCropsApi = async (accessToken, search = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: search || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchCropsSaga(action) {
  try {
    const { accessToken, search } = action.payload;
    const cropsData = yield call(getCropsApi, accessToken, search);
    yield put(fetchCropsSuccess(cropsData));
  } catch (error) {
    yield put(fetchCropsFailure(error.message));
  }
}

export default function* cropsSaga() {
  yield takeLatest(fetchCropsStart.type, fetchCropsSaga);
}
